import {useRef, useEffect} from 'react';

const useDidUpdate = (fn, inputs) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) return fn();
    else didMountRef.current = true;
  }, inputs); // eslint-disable-line
  // TODO check why deps not in an array
};

export default useDidUpdate;
